import config from 'constants/config'
import { useFlightCampaigns } from './useFlightCampaigns'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import { HOMEPAGE_FLIGHT_DEALS_REGIONS } from 'constants/config/region'
import { useContext } from 'react'
import GeoContext from 'contexts/geoContext'

export function useShowFlightCampaignsOrDeals(isHomepage: boolean = false): 'deals' | 'campaigns' | 'none' {
  const { currentRegionCode } = useContext(GeoContext)
  const [campaigns, fetchingCampaigns] = useFlightCampaigns()

  const isNewFlightCarouselEnabled = !!useOptimizelyExperiment(OptimizelyFeatureFlags.croNewFlightsSaleCarouselEnabled)

  if (fetchingCampaigns) {
    return 'none'
  }

  const campaignsEnabled = campaigns.length >= config.FLIGHTS_CAMPAIGNS_MIN_NUMBER_TO_SHOW && config.FLIGHTS_CAMPAIGNS_ENABLED
  if (campaignsEnabled) {
    return 'campaigns'
  }

  const flightDealsEnabled = isHomepage ? HOMEPAGE_FLIGHT_DEALS_REGIONS.includes(currentRegionCode) && isNewFlightCarouselEnabled : true
  if (flightDealsEnabled) {
    return 'deals'
  }

  return 'none'
}
